module.exports = __webpack_public_path__ + "static/media/FR.299e4d12.svg";